import { render, staticRenderFns } from "./HotelData.vue?vue&type=template&id=2641ded1&"
import script from "./HotelData.vue?vue&type=script&lang=js&"
export * from "./HotelData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports